import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Typography } from '@zendesk/forethought-elements';

export default function CreatePasswordError() {
  const { t } = useTranslation('authentication-wall');
  return (
    <div>
      <div>
        <Typography variant='font16Bold'>
          {t('createPasswordError.title')}
        </Typography>
      </div>
      <div>
        <Typography variant='font14'>
          {t('createPasswordError.body')}
        </Typography>
      </div>
      <div>
        <Link to='/'>{t('createPasswordError.returnToSignIn')}</Link>
      </div>
    </div>
  );
}
